import React, { useEffect, useMemo, useState } from "react";
import logo from "../../assets/Icons/QuesthireBlack.png";
import { IoMdClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { env } from "../../utilities/function";
import axios from "axios";

const AUTH_API_BASE = env("AUTHENTICATION_CLIENT")
const API_BASE = env("SERVER")

console.log({AUTH_API_BASE,API_BASE})
const jobSuggestions = [
  "Carpenter",
  "Finish Carpenter",
  "Apprentice Carpenter",
  "Carpenter Apprentice",
  "Framing Carpenter",
  "Journeyman Carpenter",
  "Construction Carpenter",
];

const finalSteps = [
  { text: (<><span className="font-bold">Curating jobs that are personalized to you.</span> Keep an eye on your inbox!</>) },
  { text: "Getting you face-to-face with employers – I work directly with 100,000+ employers each month." },
  { text: "Keeping you in the know with status updates every step of the way." },
];

const steps = [
  { title: "What job title are you interested in?", placeholder: "Job title", type: "autocomplete" },
  {
    title: "What kind of workplace are you looking for?",
    type: "select",
    options: [
      { label: "In-person", description: "Be in-person at your workplace" },
      { label: "Hybrid", description: "Split your time between in-person and remote work" },
      { label: "Remote", description: "Work from anywhere you'd like" },
    ],
  },
  {
    title: "Where do you want your remote role to be based?",
    type: "select_location_base",
    options: [
      { label: "Anywhere in CA", description: "" },
      { label: "In a specific location", description: "" },
    ],
  },
  { title: "What is the minimum you want to make?", type: "pay" },
  { title: "Got it. I have a good idea of what you want.", type: "got_it" },
  { title: "Let’s create your account", type: "signup_form" },
  { title: "", type: "profile_intro" },
  { title: "Give me a moment while I create a profile from your resume.", type: "resume_parsing" },
  { title: "Let's add your profile photo", type: "upload_photo" },
  { title: "", type: "profile_preview" },
  { title: "You're all set! Now I’ll get to work...", type: "onboarding_complete" },
];


function parseMoney(input) {
  // keep digits only, treat empty as 0
  const n = Number(String(input).replace(/[^\d.]/g, ""));
  return Number.isFinite(n) ? n : 0;
}

const Onboarding = () => {
  const [stepIndex, setStepIndex] = useState(0);
  const [suggestBoxOpen, setSuggestBoxOpen] = useState(false);
  const [payType, setPayType] = useState("Yearly");
  const [activeFinalStep, setActiveFinalStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);

  // Single source of truth for all onboarding payload
  const [form, setForm] = useState({
    joiningReason: "onboarding",           // default
    preferredJobTitle: "",                 // step 0
    workplaceType: "",                     // step 1 (In-person | Hybrid | Remote)
    locationChoice: "Anywhere in CA",      // step 2 (internal: choice label)
    preferredJobLocation: "Anywhere in CA",// step 2 actual payload (string)
    desiredMinPayInput: "",                // step 3 raw input ($1,234)
    desiredMinPay: 0,                      // step 3 numeric
    desiredPaySpan: "Yearly",              // step 3 (Yearly | Hourly)
    fullName: "",                          // step 5
    email: "",                             // step 5
    password: "",                          // step 5
    emailSubscribed: false,                // step 5
  });

  const navigate = useNavigate();

  const currentStep = steps[stepIndex];
  const isLastStep = stepIndex === steps.length - 1;
  const progress = ((stepIndex + 1) / steps.length) * 100;

  const filteredSuggestions = useMemo(
    () =>
      jobSuggestions.filter((job) =>
        job.toLowerCase().includes(form.preferredJobTitle.toLowerCase())
      ),
    [form.preferredJobTitle]
  );

  useEffect(() => {
    if (currentStep.type === "onboarding_complete" && activeFinalStep < finalSteps.length) {
      const t = setTimeout(() => setActiveFinalStep((p) => p + 1), 1500);
      return () => clearTimeout(t);
    }
  }, [currentStep.type, activeFinalStep]);

  const setField = (key, val) => {
    setForm((f) => ({ ...f, [key]: val }));
  };

  // --- Validation per step ---
  const validateStep = () => {
    switch (currentStep.type) {
      case "autocomplete":
        if (!form.preferredJobTitle.trim()) return "Please enter a job title.";
        return null;
      case "select":
        if (!form.workplaceType) return "Please choose your workplace type.";
        return null;
      case "select_location_base":
        if (form.locationChoice === "In a specific location" && !form.preferredJobLocation.trim()) {
          return "Please enter your preferred location.";
        }
        return null;
      case "pay":
        if (!form.desiredMinPayInput.trim()) return "Please enter your minimum pay.";
        if (parseMoney(form.desiredMinPayInput) <= 0) return "Please enter a valid amount.";
        return null;
      case "signup_form":
        if (!form.fullName.trim()) return "Full name is required.";
        if (!form.email.trim()) return "Email is required.";
        if (!/^\S+@\S+\.\S+$/.test(form.email)) return "Please enter a valid email.";
        if (!form.password || form.password.length < 6) return "Password must be at least 6 characters.";
        return null;
      default:
        return null;
    }
  };

  // --- API: Submit onboarding (runs on leaving signup_form step) ---
  const submitOnboarding = async () => {
    setApiError(null);
    setLoading(true);
    try {
      const body = {
        joiningReason: form.joiningReason,
        preferredJobTitle: form.preferredJobTitle,
        workplaceType: form.workplaceType,
        preferredJobLocation: form.preferredJobLocation,
        desiredMinPay: parseMoney(form.desiredMinPayInput),
        desiredPaySpan: form.desiredPaySpan, // Yearly | Hourly
        fullName: form.fullName,
        email: form.email,
        password: form.password,
        emailSubscribed: form.emailSubscribed,
      };

      const res = await fetch(`${AUTH_API_BASE}/api/auth/onboard_jobseeker`, {
        method: "POST",
        credentials: "include", // so httpOnly auth cookie from generateToken is set
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg || `Request failed (${res.status})`);
      }

      // Success: advance to profile steps
      setLoading(false);
      setStepIndex((prev) => prev + 1);
    } catch (err) {
      setLoading(false);
      setApiError(err?.message || "Something went wrong while creating your account.");
    }
  };

  const uploadResume = async (file) => {
    setApiError(null);
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("resume", file);

      const res = await axios.post(`/api/user-profile/resume`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg || `Request failed (${res.status})`);
      }

      setLoading(false);
      setStepIndex((prev) => prev + 1); // Move to next step on success
    } catch (err) {
      setLoading(false);
      setApiError(err?.message || "Something went wrong while uploading your resume.");
    }
  };
  const goNext = async () => {
    const err = validateStep();
    if (err) {
      setApiError(err);
      return;
    }
    setApiError(null);

    // Pre-step transitions / transforms
    if (currentStep.type === "pay") {
      setField("desiredMinPay", parseMoney(form.desiredMinPayInput));
      setField("desiredPaySpan", payType);
    }

    // On leaving signup_form, call API
    if (currentStep.type === "signup_form") {
      await submitOnboarding();
      return; // submitOnboarding will advance step on success
    }

    if (!isLastStep) {
      setStepIndex((i) => i + 1);
    } else {
      navigate("/jobseeker/home");
    }
  };

  const goBack = () => {
    if (stepIndex === 0) return;
    setApiError(null);
    setStepIndex((i) => Math.max(0, i - 1));
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-between px-4 pt-8 pb-0">
      {/* Header with Logo */}
      <img src={logo} alt="Questhire Logo" className="absolute left-10 -top-20 w-64 " />

      {/* Center Content */}
      <div className="flex flex-col items-center justify-center w-full flex-grow ">
        <img src="https://randomuser.me/api/portraits/men/75.jpg" alt="Avatar" className="h-16 w-16 rounded-full mb-6" />

        {currentStep.title !== "" && (
          <h2 className={`${currentStep.type === "got_it" ? "text-4xl font-bold" : "text-2xl font-semibold"}  text-center mb-6`}>
            {currentStep.title}
          </h2>
        )}

        <div className="w-full max-w-md">
          {/* Error / API messages */}
          {apiError && (
            <div className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded px-3 py-2">
              {apiError}
            </div>
          )}

          {currentStep.type === "autocomplete" && (
            <div className="relative">
              <label className="block text-left font-semibold text-sm mb-1">Job title</label>
              <input
                type="text"
                placeholder="Job title"
                value={form.preferredJobTitle}
                onChange={(e) => {
                  setField("preferredJobTitle", e.target.value);
                  setSuggestBoxOpen(true);
                }}
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring focus:border-blue-300 pr-10"
              />
              {!!form.preferredJobTitle && (
                <button
                  onClick={() => {
                    setField("preferredJobTitle", "");
                    setSuggestBoxOpen(false);
                  }}
                  type="button"
                  className="absolute right-3 top-9 text-gray-400 hover:text-black"
                  aria-label="Clear"
                >
                  <IoMdClose />
                </button>
              )}
              {suggestBoxOpen && filteredSuggestions.length > 0 && (
                <div className="absolute z-10 w-full bg-white border mt-1 rounded shadow max-h-60 overflow-y-auto">
                  {filteredSuggestions.map((s) => (
                    <div
                      key={s}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                      onClick={() => {
                        setField("preferredJobTitle", s);
                        setSuggestBoxOpen(false);
                      }}
                    >
                      {s}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {currentStep.type === "select" && (
            <div className="space-y-4">
              {currentStep.options.map((option) => (
                <label
                  key={option.label}
                  className={`flex items-start border rounded px-4 py-3 cursor-pointer hover:bg-gray-50 transition ${
                    form.workplaceType === option.label ? "border-black" : "border-gray-300"
                  }`}
                >
                  <input
                    type="radio"
                    name={`step-${stepIndex}`}
                    value={option.label}
                    checked={form.workplaceType === option.label}
                    onChange={() => setField("workplaceType", option.label)}
                    className="mt-1 mr-4"
                  />
                  <div>
                    <div className="font-semibold">{option.label}</div>
                    {option.description && <div className="text-sm text-gray-600">{option.description}</div>}
                  </div>
                </label>
              ))}
            </div>
          )}

          {currentStep.type === "select_location_base" && (
            <div className="space-y-4">
              {currentStep.options.map((option) => (
                <label
                  key={option.label}
                  className={`flex items-start border rounded px-4 py-3 cursor-pointer hover:bg-gray-50 transition ${
                    form.locationChoice === option.label ? "border-black" : "border-gray-300"
                  }`}
                >
                  <input
                    type="radio"
                    name={`loc-choice`}
                    value={option.label}
                    checked={form.locationChoice === option.label}
                    onChange={() => {
                      setField("locationChoice", option.label);
                      if (option.label === "Anywhere in CA") {
                        setField("preferredJobLocation", "Anywhere in CA");
                      } else {
                        setField("preferredJobLocation", "");
                      }
                    }}
                    className="mt-1 mr-4"
                  />
                  <div>
                    <div className="font-semibold">{option.label}</div>
                    {option.description && <div className="text-sm text-gray-600">{option.description}</div>}
                  </div>
                </label>
              ))}

              {form.locationChoice === "In a specific location" && (
                <div className="mt-2">
                  <label className="block text-left font-semibold text-sm mb-1">Preferred location</label>
                  <input
                    type="text"
                    placeholder="City, State (e.g., San Jose, CA)"
                    value={form.preferredJobLocation}
                    onChange={(e) => setField("preferredJobLocation", e.target.value)}
                    className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring focus:border-blue-300"
                  />
                </div>
              )}
            </div>
          )}

          {currentStep.type === "pay" && (
            <div>
              <div className="flex gap-4 mb-4">
                {(["Yearly", "Hourly"] ).map((type) => (
                  <button
                    key={type}
                    type="button"
                    onClick={() => {
                      setPayType(type);
                      setField("desiredPaySpan", type);
                    }}
                    className={`px-5 py-2 rounded-full border font-semibold transition ${
                      payType === type ? "border-black" : "border-gray-300"
                    }`}
                  >
                    {type}
                  </button>
                ))}
              </div>
              <label className="block text-left font-semibold text-sm mb-1">Desired minimum pay</label>
              <input
                type="text"
                value={form.desiredMinPayInput}
                onChange={(e) => setField("desiredMinPayInput", e.target.value)}
                className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring focus:border-blue-300"
                placeholder="$0"
              />
              <div className="mt-2 text-sm text-gray-500 bg-gray-100 rounded px-3 py-2">
                Employers don’t always post the salary for their jobs, but I will use this to recommend the right jobs whenever I can.
              </div>
            </div>
          )}

          {currentStep.type === "got_it" && (
            <div className="text-center text-4xl font-extrabold">
              <p className=" font-semibold text-black mb-8">
                Let's set you up so I can <span className="text-black font-extrabold">connect you to the right employers.</span>
              </p>
              <button
                type="button"
                onClick={() => setStepIndex((prev) => prev + 1)}
                className="bg-black text-lg hover:bg-[#004349] text-white px-8 py-3 rounded font-semibold transition"
              >
                Go Ahead
              </button>
            </div>
          )}

          {currentStep.type === "signup_form" && (
            <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); goNext(); }}>
              <div>
                <label className="block text-left font-semibold text-sm mb-1">Full name</label>
                <input
                  type="text"
                  placeholder="John Doe"
                  value={form.fullName}
                  onChange={(e) => setField("fullName", e.target.value)}
                  className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring focus:border-blue-300"
                />
              </div>
              <div>
                <label className="block text-left font-semibold text-sm mb-1">Email</label>
                <input
                  type="email"
                  placeholder="you@example.com"
                  value={form.email}
                  onChange={(e) => setField("email", e.target.value)}
                  className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring focus:border-blue-300"
                />
              </div>
              <div>
                <label className="block text-left font-semibold text-sm mb-1">Password</label>
                <input
                  type="password"
                  placeholder="••••••••"
                  value={form.password}
                  onChange={(e) => setField("password", e.target.value)}
                  className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring focus:border-blue-300"
                />
              </div>
              <div className="flex items-start space-x-2 text-sm">
                <input
                  id="subscribed"
                  type="checkbox"
                  checked={form.emailSubscribed}
                  onChange={(e) => setField("emailSubscribed", e.target.checked)}
                  className="mt-1"
                />
                <label htmlFor="subscribed">
                  Click here to sign up to receive email job alerts. You can unsubscribe at any time.
                </label>
              </div>
              <p className="text-xs text-gray-600">
                By clicking Next, I agree to the ZipRecruiter <span className="font-semibold underline">Terms of Use</span> and acknowledge I have
                read the <span className="font-semibold underline">Privacy Policy</span>.
              </p>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-black text-white px-6 py-2 rounded font-semibold transition disabled:opacity-60"
              >
                {loading ? "Creating your account..." : "Next"}
              </button>
            </form>
          )}

          {currentStep.type === "profile_intro" && (
            <div className="text-center">
              <h2 className="text-4xl font-medium text-black mb-6 max-w-md mx-auto">
                Next, <span className="font-extrabold">let’s create a standout profile</span> that I’ll use to introduce you to employers.
              </h2>
              <div className="flex flex-col mt-2 gap-1 justify-center">
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  id="resumeUpload"
                  className="hidden"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      uploadResume(file);
                    }
                  }}
                />
                <button
                  className="bg-black hover:bg-[#004349] text-white font-semibold px-6 py-3 rounded"
                  onClick={() => document.getElementById("resumeUpload")?.click()}
                >
                  Start From My Resume
                </button>

                <button
                  className="border border-black text-black font-semibold px-6 py-3 rounded hover:bg-white hover:text-black transition"
                  onClick={() => alert("Start from scratch")}
                >
                  Start From Scratch
                </button>
              </div>
            </div>
          )}

          {currentStep.type === "resume_parsing" && (
            <div className="text-center">
              <ul className="space-y-3 text-left text-lg  font-medium text-gray-700 max-w-xs mx-auto">
                {["Looking for experience", "Checking for education", "Pulling out relevant skills", "Finishing up..."].map((item, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <span className={`h-3 w-3 rounded-full border-2 ${index === 0 ? "bg-black border-black" : "border-gray-400"}`}></span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {currentStep.type === "upload_photo" && (
            <div className="text-center">
              <div className="flex flex-col items-center space-y-10">
                <div className="w-32 h-32 bg-gray-200 rounded-full flex items-center justify-center">
                  <svg className="w-14 h-14 text-gray-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v1.2c0 .6.4 1.2 1.2 1.2h16.8c.6 0 1.2-.4 1.2-1.2v-1.2c0-3.2-6.4-4.8-9.6-4.8z" />
                  </svg>
                </div>

                <div className="bg-gray-100 text-sm  text-start text-gray-700 rounded px-4 py-2 max-w-sm mx-auto">
                  <p className="font-semibold">Stand out with a profile photo</p>
                  <p>Your profile photo will be shown to hiring managers as part of your application</p>
                </div>

                <input
                  id="photoUpload"
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) alert(`Uploaded: ${file.name}`);
                  }}
                />

                <button
                  onClick={() => document.getElementById("photoUpload")?.click()}
                  className="bg-black font-bold w-full mt-20 text-white px-6 py-3 rounded  hover:bg-black"
                >
                  Upload Photo
                </button>
                <button onClick={() => setStepIndex((prev) => prev + 1)} className=" text-black font-bold  hover:text-[#004349] mt-2">
                  Skip
                </button>
              </div>
            </div>
          )}

          {currentStep.type === "profile_preview" && (
            <div className="w-full max-w-2xl mx-auto text-[#002d2d] text-sm">
              <h2 className="text-center text-lg font-semibold mb-6">
                Here’s your ZipRecruiter profile – <br />
                <span className="font-bold">check it out!</span>
              </h2>

              <div className="bg-gray-100 rounded-lg px-4 py-4 mb-4">
                <div className="flex justify-between items-center mb-1">
                  <p className="text-sm font-semibold">Let employers find you</p>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" className="sr-only peer" defaultChecked />
                    <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-500 rounded-full peer peer-checked:bg-black transition-all duration-300"></div>
                    <div className="absolute left-1 top-1 bg-white w-4 h-4 rounded-full peer-checked:translate-x-full transition-transform"></div>
                  </label>
                </div>
                <p className="text-gray-600 text-xs">
                  Public: Hiring managers will be able to view your profile and reach out about potential opportunities.
                </p>
              </div>

              <div className="space-y-4 text-left">
                <div className="flex items-center gap-2">
                  <div className="bg-gray-300 h-6 w-6 rounded-full"></div>
                  <span className="font-medium text-sm">{form.preferredJobTitle || "—"}</span>
                </div>

                <div>
                  <p className="text-gray-600 font-medium text-xs mb-0.5">Contact Information</p>
                  <p className="text-sm">{form.email || "—"}</p>
                </div>

                <div>
                  <p className="text-gray-600 font-medium text-xs mb-0.5">Preferences</p>
                  <p className="text-sm">
                    {form.workplaceType || "—"} · {form.preferredJobLocation || "—"} · {form.desiredPaySpan} ${form.desiredMinPay || 0}+
                  </p>
                </div>
              </div>
            </div>
          )}

          {currentStep.type === "onboarding_complete" && (
            <div className="text-center text-black w-full max-w-2xl mx-auto px-4">
              <ul className="space-y-6 text-left text-sm font-medium max-w-md mx-auto">
                {finalSteps.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    {index < activeFinalStep ? (
                      <svg className="w-5 h-5  mt-1" fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    ) : index === activeFinalStep ? (
                      <svg className="animate-spin w-5 h-5 text-gray-500 mt-1" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                        ></path>
                      </svg>
                    ) : (
                      <span className="w-5 h-5 border-2 border-gray-400 rounded-full mt-1"></span>
                    )}
                    <p className={`leading-snug ${index > activeFinalStep ? "text-gray-400" : ""}`}>{item.text}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Bottom Nav & Progress */}
      <div className="w-full px-4 border-t border-gray-200">
        <div className="mx-auto py-6">
          <div className="w-full h-1 bg-gray-200 rounded-full mb-6">
            <div className="h-full bg-black rounded-full transition-all duration-300" style={{ width: `${progress}%` }}></div>
          </div>

          <div className="flex justify-between">
            <button
              disabled={stepIndex === 0 || loading}
              onClick={goBack}
              className="text-gray-700 underline disabled:opacity-50"
            >
              Back
            </button>
            <button
              onClick={goNext}
              disabled={loading}
              className="bg-black text-white px-6 py-2 rounded transition disabled:opacity-60"
            >
              {currentStep.type === "signup_form" ? (loading ? "Submitting..." : "Next") : isLastStep ? "Finish" : "Next"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;

